var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStockAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 97,
    viewBox: "0 0 119 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 2L1.5 22V74.5L50 94.5L97 76L95.5 22L48.5 2Z",
    fill: "#E5F3ED",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1119 20.6341V20.4608C98.0645 20.3403 98.0066 20.2243 97.9386 20.1141L97.8086 19.9408L97.5486 19.6591L97.3969 19.5291L97.1152 19.3991H97.0069L49.9444 0.15804C49.4232 -0.0526799 48.8404 -0.0526799 48.3193 0.15804L1.36507 19.0741H1.25673L0.975052 19.2041L0.823376 19.3341L0.563361 19.6157L0.433357 19.7891C0.365374 19.8993 0.307411 20.0153 0.260013 20.1358V20.3091C0.237262 20.489 0.237262 20.671 0.260013 20.8508C0.260013 50.5144 0 49.6915 0 75.3454C0.00433357 76.2202 0.534381 77.0065 1.3434 77.3388L48.3193 96.8399C48.5541 96.9331 48.8035 96.9842 49.056 96.9916C49.3084 96.9842 49.5579 96.9331 49.7927 96.8399L96.7685 77.3388C97.5775 77.0065 98.1076 76.2202 98.1119 75.3454V21.1758C98.1347 20.996 98.1347 20.814 98.1119 20.6341ZM49.8556 5.29125L64.728 11.6853L25.6784 28.0899L10.091 21.8455L49.8556 5.29125ZM46.1545 90.8833L5.0682 73.159C5.0682 45.1657 5.0682 64.0442 5.0682 25.074L20.8878 31.921L46.1545 42.7549V90.8833ZM49.1426 37.6238L32.025 30.4517L71.118 13.9821L88.8639 21.8671L64.4835 31.9664L49.1426 37.6238ZM52.0224 90.8833V42.7549L63.4867 37.6847L93.0871 25.0306L93.1954 73.159L52.0224 90.8833Z",
    fill: "#0E4C54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.3477,
    cy: 72.5,
    r: 20.5,
    fill: "white",
    stroke: "#0E4C54",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.149 65.7832C105.105 64.7389 103.412 64.7389 102.368 65.7832L93.5535 74.5974L90.5646 71.6085C89.5204 70.5642 87.8274 70.5642 86.7832 71.6085C85.7389 72.6527 85.7389 74.3457 86.7832 75.3899L91.4765 80.0833C91.5318 80.1505 91.5909 80.2157 91.6537 80.2786C92.698 81.3228 94.391 81.3228 95.4352 80.2786L106.149 69.5646C107.193 68.5204 107.193 66.8274 106.149 65.7832Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStockAvailable);
export default __webpack_public_path__ + "static/media/icon-stock-available.ca8d7b10469a4ef418d2d7a86d32fabd.svg";
export { ForwardRef as ReactComponent };